import { render, staticRenderFns } from "./zhipaiwuhuo.vue?vue&type=template&id=181ac99b&scoped=true&"
import script from "./zhipaiwuhuo.vue?vue&type=script&lang=js&"
export * from "./zhipaiwuhuo.vue?vue&type=script&lang=js&"
import style0 from "./zhipaiwuhuo.vue?vue&type=style&index=0&id=181ac99b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181ac99b",
  null
  
)

export default component.exports